export default __webpack_public_path__ + "img/bgsHHMrg.31f3c90e.svg";